// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditableRowContainer_XjyIp {
  display: flex;
  flex-direction: column;
  gap: 10px;
  label {
    display: flex;
    border: none;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin: 0;
    &:hover {
      button {
        opacity: 1;
      }
    }
    button {
      opacity: 0;
    }
  }
  p {
    margin: 0;
    color: #18181b;
  }

  .addPercent_czUxG {
    width: 100%;
    border: none;
    outline: none;
    padding: 8px;
    cursor: pointer;
  }
  .infoTotal_ZJKns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    input {
      outline: none;
      border: none;
      background-color: var(--f4-background);
      padding: 12px;
      box-sizing: border-box;
      font-family: "Inter", sans-serif;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      -ms-border-radius: 5px;
      -o-border-radius: 5px;
        font-size: 14px;
        font-weight: 400;
        color: var(--_75-color);
        min-height: 21px !important;
        box-sizing: border-box;
        width: 100%;
      &:disabled
{
        background-color: transparent;
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Preview/EditableRow/EditableRow.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT;MACE;QACE,UAAU;MACZ;IACF;IACA;MACE,UAAU;IACZ;EACF;EACA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B;MACE,aAAa;MACb,YAAY;MACZ,sCAAsC;MACtC,aAAa;MACb,sBAAsB;MACtB,gCAAgC;MAChC,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;QACnB,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,2BAA2B;QAC3B,sBAAsB;QACtB,WAAW;MACb;;QAEE,6BAA6B;MAC/B;IACF;EACF;AACF","sourcesContent":[".EditableRowContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  label {\n    display: flex;\n    border: none;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n    margin: 0;\n    &:hover {\n      button {\n        opacity: 1;\n      }\n    }\n    button {\n      opacity: 0;\n    }\n  }\n  p {\n    margin: 0;\n    color: #18181b;\n  }\n\n  .addPercent {\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 8px;\n    cursor: pointer;\n  }\n  .infoTotal {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    input {\n      outline: none;\n      border: none;\n      background-color: var(--f4-background);\n      padding: 12px;\n      box-sizing: border-box;\n      font-family: \"Inter\", sans-serif;\n      border-radius: 5px;\n      -webkit-border-radius: 5px;\n      -moz-border-radius: 5px;\n      -ms-border-radius: 5px;\n      -o-border-radius: 5px;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_75-color);\n        min-height: 21px !important;\n        box-sizing: border-box;\n        width: 100%;\n      &:disabled\n{\n        background-color: transparent;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EditableRowContainer": `EditableRowContainer_XjyIp`,
	"addPercent": `addPercent_czUxG`,
	"infoTotal": `infoTotal_ZJKns`
};
export default ___CSS_LOADER_EXPORT___;
